import ContentLibrary from './ContentLibrary';

export default ContentLibrary;
